'use client';

import { Box } from '@terra/ui-styled-system';
import { ArrowDown01Icon, ArrowRight01Icon } from '@terra/ui-icons';
import type { TracePhase } from '../types';
import { createHideOnContextMenuHandler } from '../utils/hide-on-context-menu';

type TraceExpandChevronProps = {
  isExpanded: boolean;
  size?: number;
  tracePhase?: TracePhase;
  onHideMessage?: () => void;
};

export function TraceExpandChevron({
  isExpanded,
  size = 10,
  onHideMessage,
}: TraceExpandChevronProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      color="fg.muted"
      flexShrink={0}
      onContextMenu={createHideOnContextMenuHandler(onHideMessage)}
      cursor={onHideMessage ? 'context-menu' : undefined}
    >
      {isExpanded ? (
        <ArrowDown01Icon size={size} />
      ) : (
        <ArrowRight01Icon size={size} />
      )}
    </Box>
  );
}
